/* CommandPalette — ⌘K overlay. `.backdrop` is the fixed dim scrim (dialog
 * convention shared with FeedbackModal); `.panel` sits near top-center
 * rather than vertically centered so it doesn't jump around the viewport
 * as the filtered row count changes. */

.backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  /* Top-anchored, not vertically centered — a palette that recenters as
   * rows filter in/out is distracting; anchoring near the top keeps it
   * still while the row count changes underneath. */
  padding-top: 12vh;
  background: var(--bg-scrim);
  z-index: var(--z-modal);
}

.panel {
  width: 100%;
  max-width: 480px;
  max-height: 60vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  box-shadow: var(--shadow-dialog);
  overflow: hidden;
}

.input {
  width: 100%;
  padding: var(--spacing-12) var(--spacing-16);
  font: var(--text-body-regular);
  color: var(--text-primary);
  background: var(--bg-primary);
  border: none;
  border-bottom: 1px solid var(--stroke-neutral);
  outline: none;
}

.input::placeholder {
  color: var(--text-tertiary);
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: var(--spacing-8);
  overflow-y: auto;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-8);
  padding: var(--spacing-8) var(--spacing-8);
  border-radius: var(--radius-8);
  color: var(--text-primary);
  cursor: pointer;
}

.active {
  background: var(--bg-secondary);
}

.label {
  font: var(--text-body-regular);
}

.hint {
  font: var(--text-micro-regular);
  color: var(--text-tertiary);
  white-space: nowrap;
}

.noResults {
  padding: var(--spacing-8) var(--spacing-8);
  font: var(--text-body-regular);
  color: var(--text-tertiary);
}
